import React, { ReactNode, FC, useState } from 'react';


type Props = {
    tabList: ReactNode[],
    contents: ReactNode[],
};


export const TabSection: FC<Props> = ({ tabList, contents }) => {
    const [selected, setSelected] = useState(0);
    const panels = contents.map((content) => {
        return <div className="panel">{content}</div>;
    });

    return (
        <section className="tabs">
            <ul className="tablist">
                {tabList.map((tab, index) => {
                    return (
                        <li className={selected === index ? "tab selected" : "tab"} onClick={() => setSelected(index)}>{tab}</li>
                    );
                })}
            </ul>
            {panels[selected]}

            <style jsx>{`
                .tabs {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin: 24px auto;
                    margin-bottom: 70px;
                    width: 762px;
                }
                li {
                    cursor: pointer;
                }
                .tablist {
                    list-style-type: none;
                    display: flex;
                    justify-content: space-between;
                    margin: 0;
                    padding-left: 12px;
                    padding-right: 12px;
                }
                .tab {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 48.5%;
                    height: 36px;
                    font-size: 14px;
                    background-color: #f7f7f7;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-radius: 20px 20px 0 0;
                    color: #fd862c;
                }
                .tab:nth-first-child(1) {
                    margin-right: 12px;
                }
                .selected {
                    background-color: #fff;
                    color: black;
                }
                :global(.panel) {
                    flex: 1;
                    background: #fff;
                    padding-top: 60px;
                    padding-left: 50px;
                    padding-right: 50px;
                    padding-bottom: 80px;
                }
                @media screen and (max-width: 715px) {
                    .tabs {
                        padding: 0;
                        margin: 0;
                        width: 100%;
                        margin-top: 12px;
                    }
                    .tablist {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    .tab {
                        height: 30px;
                        font-size: 12px;
                    }
                    :global(.panel) {
                        padding-top: 18px;
                        padding-left: 21px;
                        padding-right: 21px;
                        padding-bottom: 30px;
                    }
                }
            `}</style>
        </section>
    );
};
